<template>
    <div class="registrationWrapper">
        <div class="container">
            <div class="whiteBG-wrap">
                <div class="row">                
                    <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-7">
                        <div class="regForm-wrap">
                            <h2>Signature & Verification</h2>
                            <hr>
                            <signature-form />
                        </div>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-5">
                        <signature-side-info />
                    </div>                    
                </div>
                <span class="procecss-title">Employer Registration</span>
            </div>
        </div>        
    </div>
</template>
<script>
import SignatureForm from '../../components/Registration/SignatureVerification/SignatureForm.vue'
import SignatureSideInfo from '../../components/Registration/SignatureVerification/SignatureSideInfo.vue'
export default {
    name: 'SignatureVerification',
    components: {
        SignatureForm,
        SignatureSideInfo
    }
}
</script>
<style src="../../assets/css/group-registration.css"></style>